import { HStack, Icon, Text } from "@chakra-ui/react";
import { InfoIcon } from "../../../icons";

export function CardListInfo() {
  return (
    <HStack w="100%" p="20px" bg="white" borderRadius="16px" alignItems="flex-start">
      <Icon as={InfoIcon} boxSize="24px" mr="6px" />

      <Text fontSize="12.5px" lineHeight="17px">
        В дату платежа автоматически спишем с основного способа оплаты .
        Если оплата не пройдёт, попробуйте другой способ оплаты.
      </Text>
    </HStack>
  );
}
